import React from 'react';
import {Link} from 'gatsby';

import ExtLink from './ExtLink';

import Facebook from '../svg/facebook.svg';
import Twitter from '../svg/twitter.svg';
import Instagram from '../svg/instagram.svg';
import YouTube from '../svg/youtube.svg';
import Flickr from '../svg/flickr.svg';

import styles from './Footer.module.scss';

const Footer = () => (
  <footer className={styles.container}>
    <div className="wrap">
      <p>
        Câmara dos Deputados<br />
        Gabinete 623 - Anexo 4<br />
        CEP 70160-900 - Brasília/DF<br />
        Telefone: (61) 3215-5617<br />
        E-mail: <a href="mailto:contato@samiabomfim.com.br">contato@samiabomfim.com.br</a>
      </p>

      <p>
        Copyleft © 2020 Sâmia Bomfim. O conteúdo deste site, exceto quando proveniente de outras fontes ou onde especificado o contrário, está licenciado sob a <ExtLink to="https://creativecommons.org/licenses/by-sa/3.0/br/">Creative Commons by-sa 3.0 BR</ExtLink>.
      </p>

      <p className={styles.links}>
        <Link to="/politica-de-privacidade">Política de privacidade</Link> | <Link to="/transparencia">Transparência</Link>
      </p>

      <div className={styles.social}>
        <ExtLink to="https://facebook.com/samia.bomfim.psol/"><Facebook /></ExtLink>
        <ExtLink to="https://twitter.com/samiabomfim/"><Twitter /></ExtLink>
        <ExtLink to="https://instagram.com/samiabomfim/"><Instagram /></ExtLink>
        <ExtLink to="https://youtube.com/samiabomfim/"><YouTube /></ExtLink>
        <ExtLink to="https://flickr.com/photos/samiabomfim/"><Flickr /></ExtLink>
      </div>
    </div>
  </footer>
);

export default Footer;
